import "./reportV2.css";
import * as React from "react";
import { RootState } from "../../../core/reducers";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import ClipboardJS from "clipboard";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MuscleData, IconsItem } from "../report/postureMuscle";
import userLogoIcon from "../../../assets/reportIcon/userLogoIcon.png";
import userSexIcon from "../../../assets/reportIcon/userSexIcon.png";
import userAgeIcon from "../../../assets/reportIcon/userAgeIcon.png";
import userHeightIcon from "../../../assets/reportIcon/userHeightIcon.png";
import userWeightIcon from "../../../assets/reportIcon/userWeightIcon.png";

import middleRiskBg from "../../../assets/reportIcon/middleRiskBg.png";
import highRiskBg from "../../../assets/reportIcon/highRiskBg.png";
import normalRiskBg from "../../../assets/reportIcon/normalRiskBg.png";

import arrow from "../../../assets/reportIcon/arrow.png";

import { message, Input, Divider } from "antd";
import { PostureData, formatData } from "../report/postureData";
import {GetPostureReportResponse, PostureService, RiskResult} from "../../../core/adapters";
import { CanvasEnum } from "../report/muscle";
import { RiskCanvas } from "../report/riskCanvas";
import { RiskDetailCanvas } from "../report/riskDetailCanvas";
import { analysisConclusion, getRiskByMuscleKey } from "../report/advice";
import {
  getReportPageDataByUuidAndExamineeId,
  GetReportPageDataByUuidAndExamineeIdArgs,
  saveExaminerResultAndUpdateExamination,
  SaveExaminerResultAndUpdateExamination,
  ReportData,
  updatePosturePoints,
  getExaminerResult,
} from "../../../core/actions/institution";
import { DotData, Direction } from "../report/postureData.type";
// @ts-ignore
import {ExaminationService, ExaminerResult} from "../../../core/adapters";
import MuscleCom from "../report/muscleCom";
import { useIntl, FormattedMessage } from "react-intl";
const { TextArea } = Input;
var _ = require("lodash");
import logo from "../../../assets/images/logo_xz.png";
import moment from "moment";
import axios from "axios";
import UrlUtils from "../../../utils/url";
import loading from "../../../assets/images/loading.gif";
import {post, url} from "../../../assets/javascripts/http";
import { getLanguageCode } from "../../../assets/javascripts/intl";
import AppReportHead from "../report/AppReportHead";
import DoctorSignatureSimple from "../report/DoctorSignatureSimple";
import Toolbox from "../report/Toolbox";
import "../report/toolbox.css";
import { ProtractorTool } from "../report/ProtractorTool";
import { AdvancedProtractorTool } from "../report/AdvancedProtractorTool";
import { SimpleProtractorTool } from "../report/SimpleProtractorTool";
import { OverlayCanvasManager } from "../report/OverlayCanvasManager";
let examinationService = new ExaminationService(url, post);
let postureService = new PostureService(url, post);
export interface ReportStateProps {
  posture: GetPostureReportResponse;
  frontRisks: Array<IconsItem>;
  examinerResult: Array<ExaminerResult>;
  examinerItem: ExaminerResult;
  sideRisks: Array<IconsItem>;
  backRisks: Array<IconsItem>;
  risks: Array<RiskResult>;
  risksLabels: Array<any>;
  reportPageData: ReportData;
  postureFrontData: Object;
  postureSideData: Object;
  postureBackData: Object;
  user: Array<any>;
  postureData: any;
  currentCanvasId: string;
  directionList: Array<Direction>;
  doctorMsg: string;
  diagnosisName: string;
  slide: boolean;
  show: boolean;
  scale: number;
  scaleBig: number;
  showModel: boolean;
  isSave: boolean;
  riskItem: RiskResult;
  isShowRiskDetail: boolean;
  currentImg: HTMLImageElement;
  frontImg: HTMLImageElement;
  sideImg: HTMLImageElement;
  otherSideImg: HTMLImageElement;
  backImg: HTMLImageElement;
  doctorName: string;
  doctorResume: string;
  width: number;
  height: number;
  clientHeight: number;
  clientWidth: number;
  isAuth: boolean;
  orgName: string;
  language: string;
  isDown: boolean;
  reloadCount: number;
  intervalId: any;
  evaluateTime: string;
  signature: string;
  patientId: string;
  activeTool: string;
  showToolbox: boolean;
}
export interface ReportDispatchProps {
  getReportPageDataByUuidAndExamineeId(args: GetReportPageDataByUuidAndExamineeIdArgs): void;
  updatePosturePoints(args: GetPostureReportResponse): void;
  saveExaminerResultAndUpdateExamination(args: SaveExaminerResultAndUpdateExamination): void;
  getExaminerResult(): void;
}
export interface ReportProps {
  reportPageData: ReportData;
  institution: any;
  examinerResult: Array<ExaminerResult>;
}

interface RouteParams {
  uuid: string;
}
type PropsType = RouteComponentProps<RouteParams> & ReportProps;

class Report extends React.Component<PropsType & ReportDispatchProps, ReportStateProps> {
  currentPosture: PostureData = Object.assign({});
  protractorTool: ProtractorTool | null = null;
  overlayManager: OverlayCanvasManager | null = null;

  state: ReportStateProps = {
    riskItem: Object.assign({}),
    examinerItem: Object.assign({}),
    currentImg: Object.assign({}),
    posture: Object.assign({}),
    reportPageData: Object.assign({ doctorName: "" }),
    frontRisks: [],
    examinerResult: [],
    isShowRiskDetail: false,
    show: false,
    showModel: false,
    clientHeight: 500,
    clientWidth: 500,
    isSave: false,
    scale: 0.6,
    scaleBig: 1,
    sideRisks: [],
    backRisks: [],
    currentCanvasId: "front",
    directionList: [],
    risks: [],
    risksLabels: [],
    postureFrontData: {},
    postureSideData: {},
    postureBackData: {},
    postureData: {},
    doctorName: "",
    signature: "",
    doctorResume: "",
    user: [
      {
        name: <FormattedMessage id="name" />,
        icon: userLogoIcon,
        value: "value",
        unit: "",
      },
      {
        name: <FormattedMessage id="gender" />,
        icon: userSexIcon,
        value: "value",
        unit: "",
      },
      {
        name: <FormattedMessage id="age" />,
        icon: userAgeIcon,
        value: "value",
        unit: <FormattedMessage id="year" />,
      },
      {
        name: <FormattedMessage id="height" />,
        icon: userHeightIcon,
        value: "value",
        unit: "cm",
      },
      {
        name: <FormattedMessage id="weight" />,
        icon: userWeightIcon,
        value: "value",
        unit: "kg",
      },
      {
        name: <FormattedMessage id="time" />,
        icon: userWeightIcon,
        value: "value",
        unit: "",
      },
      {
        name: <FormattedMessage id="patientId" />,
        icon: userWeightIcon,
        value: "value",
        unit: "",
      },
    ],
    doctorMsg: "",
    slide: false,
    diagnosisName: "",
    frontImg: Object.assign({}),
    sideImg: Object.assign({}),
    otherSideImg: Object.assign({}),
    backImg: Object.assign({}),
    width: 0,
    height: 0,
    isAuth: false,
    orgName: "",
    language: "",
    isDown: true,
    reloadCount: 0,
    intervalId: 0,
    evaluateTime:'',
    patientId: '',
    activeTool: '',
    showToolbox: false
  };
  async componentWillMount() {
    // this.props.getReportPageDataByUuidAndExamineeId({
    //     examinationReportId:320,
    // })
    // this.props.getExaminerResult()
  }
  onSlide = (e: React.MouseEvent) => {
    e.stopPropagation();
    let slide = !this.state.slide;
    this.setState({ slide });
  };
  isReportCompleted = (postureData) => {
    let tempDownState;
    if (postureData.status == 'PROCESSING' && postureData.resultPosture == "NULL") {
      this.setState({
        isDown: false,
        reloadCount: this.state.reloadCount+1
      });
      tempDownState = false;
    } else {
      this.setState({
        isDown: true,
        reloadCount: this.state.reloadCount+1
      });
      tempDownState = true;
    }
    if (this.state.reloadCount > 3) {
      clearInterval(this.state.intervalId)
    }
    return tempDownState;
  };

  checkReportExists = async () => {
    let that = this, pageData;
    let uuid = this.props.match.params.uuid;
    let examinationReport = await examinationService.getExaminationReportByExamineeReportDetailId({
      examineeReportDetailId: uuid,
    });
    await postureService.getPostureReport({
      uuid: examinationReport.examinationReportResult.examineeReportDetailId || "",
      language: getLanguageCode(),
    }, UrlUtils.isTrial() ? examinationReport.examinationReportResult.examinerAccountId : undefined).then(function (res) {
      pageData = res
      that.isReportCompleted(res)
    });
    return pageData;
  }

  startInterval=()=>{
    const id = setInterval(() => {
      this.checkReportExists()
      if (this.state.isDown) {
        window.location.href = window.location.href + "&editable=true"
        clearInterval(this.state.intervalId)
      }
    }, 5000);
    this.setState({
      intervalId: id
    });
  }
  componentWillReceiveProps(props) {
    let _this = this;
    let reportPageData: ReportData = props.reportPageData;
    let examinerResult = props.examinerResult;
    let status = this.isReportCompleted(reportPageData.postureData)
    if (!status){
      this.startInterval()
    }
    let doctorMsgDiv = document.getElementById("doctorMsg");
    // @ts-ignore
    if (doctorMsgDiv != null) {
      doctorMsgDiv.addEventListener("blur", function () {
        _this.setState({
          doctorMsg: this.innerText,
        });
      });
    }

    const clipboard = new ClipboardJS(".copy");

    clipboard.on("success", function (e) {
      toast.success("复制成功!");
      console.log("success");
    });

    this.setState({
      language: (function () {
        let url = new URL(location.href);
        let languageCode = url.searchParams.has("language") ? url.searchParams.get("language")! : "en";
        if (languageCode.startsWith("zh_Hant") || ["zh_tw", "zh-HK", "zh-TW"].includes(languageCode)) {
          languageCode = "zh-Hant";
        } else if (languageCode.startsWith("zh_Hans") || ["zh", "zh-CN"].includes(languageCode)) {
          languageCode = "zh-Hans";
        } else if (languageCode.search("id") !== -1) {
          languageCode = "hi";
        }
        return languageCode;
      })(),
    });

    axios
        .post("https://api.xingzheng.tech/base.persona.PersonaService/GetAllPersona", {
          accountIds: [reportPageData.examinationReportResult.examinerAccountId],
        })
        .then((res) => {
          this.setState({
            doctorName: res.data.allPersona[0].socialResult.displayName,
            doctorResume: res.data.allPersona[0].workInfoResult.resume
          });
        });
    axios
        .post("https://api.xingzheng.tech/base.persona.PersonaService/GetWorkByAccountIds", {
          accountIds: [reportPageData.examinationReportResult.examinerAccountId],
        })
        .then((res) => {
          console.log(res)
          if (res.data && res.data.workInfoResults && res.data.workInfoResults.length > 0 && res.data.workInfoResults[0]) {
            this.setState({
              signature: res.data.workInfoResults[0].signature || ''
            })
          }
        });
    axios
      .get("https://api.xingzheng.tech/solution.video.LicenseService/CheckOrganizationLicense", {
        params: {
          organizationId:
            reportPageData.examinationReportResult && reportPageData.examinationReportResult.organizationId,
          client: "right_gait_posture",
        },
      })
      .then((res) => {
        this.setState({
          isAuth: res.data.valid,
        });
      });

    axios
      .post(`https://api.xingzheng.tech/base.organization.OrganizationService/GetOrganizationByIds`, {
        ids: reportPageData.examinationReportResult && reportPageData.examinationReportResult.organizationId,
      })
      .then((res) => {
        const data = res.data.organizations || [];
        this.setState({
          orgName: data[0] && data[0].name,
        });
      });
    let muscleData = new MuscleData(reportPageData.postureData)
    let risks = muscleData.getRiskData()
    risks = this.otherIndicators(risks, reportPageData.postureData, muscleData);
    let docMsg = analysisConclusion(risks);
    reportPageData.doctorMsg.length == 0 ? (reportPageData.doctorMsg = docMsg) : "";
    let postureDataStr = JSON.stringify(reportPageData.postureData)
    let postureDataJson = JSON.parse(postureDataStr)
    let atrMsg = ""
    if (postureDataJson.maxAtrAngle) {
      atrMsg = "最大ATR角度："+postureDataJson.maxAtrAngle+"°，（正常0 ~ 4°  ；脊柱侧弯低风险4 ~ 7°  ；脊柱侧弯高风险7 ~ 15° ）\n" +
          "评估结果说明\n" +
          "根据《中国青少年脊柱侧凸筛查临床实践指南及路径指引》建议将脊柱侧凸测量尺测得的躯干旋转角度大于5度作为筛查的阳性指标，建议在3个月内转诊至医院，以明确诊断。"
    }
    this.draw(reportPageData);
    let institution = props.institution || {};
    let realName = institution.realName || "";
    this.setState({
      reportPageData,
      doctorMsg: reportPageData.doctorMsg + atrMsg,
      doctorName: realName,
      evaluateTime: moment((reportPageData['examinationReportResult']['evaluateTime'] as any)?.seconds * 1000 || new Date()).format("YYYY年MM月DD日"),
      examinerResult: examinerResult,
    });
    if (reportPageData.update) {
      this.setState({
        show: false,
      });
    }
  }

  readonlyUrl = () => {
    const url = new URL(location.href);
    url.searchParams.delete("editable");
    return url.toString();
  };

  onShowDetail = () => {
    let isShowRiskDetail = this.state.isShowRiskDetail;
    this.setState({ isShowRiskDetail: !isShowRiskDetail });
  };

  draw = async (reportPageData: ReportData) => {
    let scale = 1;
    let examineeResultStr = JSON.stringify(reportPageData.examinationReportResult.examineeResult)
    let examineeResultJson = JSON.parse(examineeResultStr)
    let gen = {
      GENDER_UNKNOWN: "未知",
      MALE: <FormattedMessage id="male" />,
      FEMALE: <FormattedMessage id="female" />,
    };
    let user = this.state.user;
    let originUser = reportPageData.user || {};
    user[0]["value"] = originUser.name;
    user[1]["value"] = gen[originUser.gender] || "未知";
    user[2]["value"] = originUser.age || 0;
    user[3]["value"] = originUser.heightScalar || 0;
    user[4]["value"] = originUser.weightScalar || 0;
    user[5]["value"] = reportPageData.reportGenDate || "";
    user[6]["value"] = examineeResultJson.patientId || "";

    let res = reportPageData.postureData;
    if (!res) {
      return;
    }

    let frontUrl = res.front || "";
    let sideUrl = res.side || "";
    let otherSideUrl = res.otherSide || "";
    let backUrl = res.back || "";

    if (res.body && res.body) {
      let directionList: Direction[] = [];
      let facePointsMin = formatData({ data: res, direction: "front" });

      let sidePointsMin = formatData({ data: res, direction: "side" });

      let otherSidePointsMin = formatData({ data: res, direction: "otherSide" });

      let backPointsMin = formatData({ data: res, direction: "back" });

      Object.keys(res.body).forEach((key) => {
              // 类型断言：确保 key 符合 Direction 类型
              directionList.push(key as Direction);
            });

      let frontImg = new Image();
      frontImg.src = frontUrl;
      frontImg.onload = () => {
        let drawCanvasFace = new PostureData({
          canvasId: "front",
          img: frontImg,
          data: facePointsMin,
          directon: "front",
          risks: res.body,
        });
        let w = frontImg.width;
        let h = frontImg.height;
        let clientHeight = window.screen.availHeight * 0.76;
        let clientWidth = window.screen.availWidth * 0.76;

        this.setState({
          width: w,
          clientHeight,
          clientWidth,
          height: h,
        });
      };
      this.setState({ frontImg: frontImg });

      let sideImg = new Image();
      sideImg.src = sideUrl;
      sideImg.onload = () => {
        let drawCanvas = new PostureData({
          canvasId: "side",
          img: sideImg,
          data: sidePointsMin,
          directon: "side",
          risks: res.body,
        });
      };
      this.setState({ sideImg: sideImg });

      let otherSideImg = new Image();
      otherSideImg.src = otherSideUrl;
      otherSideImg.onload = () => {
        let drawCanvasOtherSide = new PostureData({
          canvasId: "otherSide",
          img: otherSideImg,
          data: otherSidePointsMin,
          directon: "otherSide",
          risks: res.body,
        });
      };
      this.setState({ otherSideImg: otherSideImg });

      let backImg = new Image();
      backImg.src = backUrl;
      backImg.onload = () => {
        let drawCanvasback = new PostureData({
          canvasId: "back",
          img: backImg,
          data: backPointsMin,
          directon: "back",
          risks: res.body,
        });
      };
      this.setState({ backImg: backImg });
      let muscleData = new MuscleData(res);
      let risks = muscleData.getRiskData();
      risks = this.otherIndicators(risks, res, muscleData);

      let risksLabelSet = new Set();
      let risksLabelArray: any = [];
      risks.filter((item) => {
        if (item.level == "severe") {
          risksLabelSet.add("high");
        }
        if (item.level == "mild") {
          risksLabelSet.add("middle");
        }
        if (item.level == "normal") {
          risksLabelSet.add("normal");
        }
      });
      risksLabelSet.forEach((item) => {
        if (item == "high") {
          risksLabelArray[2] = item;
        }
        if (item == "middle") {
          risksLabelArray[1] = item;
        }
        if (item == "normal") {
          risksLabelArray[0] = item;
        }
      });
      this.setState({
        risks: risks,
        risksLabels: risksLabelArray,
        user: user,
        posture: res,
        directionList: directionList,
      });
      console.log(res);
      new RiskCanvas(res);
    }
  };
  otherIndicators = (risks, res, muscleData: MuscleData) => {
    const getPointCoordinate = (direction: string, part: string, side: string, axis: 'x' | 'y') => {
      return res.body[direction]?.points?.[part]?.[side]?.[axis] || 0;
    };
    
    const getDepthPointDistance = (direction: string, partA: string, partB: string, side: string, axis: 'x' | 'y') => {
      const depthData = res.depthData;
      if (!depthData) return null;

      const depthItem = depthData.find((item) => item.shootingAngle === direction);
      const pointA = depthItem?.keypoints?.[`${side}${partA}`];
      const pointB = depthItem?.keypoints?.[`${side}${partB}`];

      if (!pointA || !pointB) return null;

      return Math.abs(Math.abs(pointA[axis]) - Math.abs(pointB[axis]));
    };

    const earX = getPointCoordinate('side', 'ear', 'right', 'x');
    const hipX = getPointCoordinate('side', 'hip', 'right', 'x');
    const hipY = getPointCoordinate('side', 'hip', 'right', 'y');
    const shoulderX = getPointCoordinate('side', 'shoulder', 'right', 'x');
    const shoulderY = getPointCoordinate('side', 'shoulder', 'right', 'y');
    const hipXLeft = getPointCoordinate('otherSide', 'hip', 'left', 'x');
    const wristXLeft = getPointCoordinate('otherSide', 'wrist', 'left', 'x');
    const wristXRight = getPointCoordinate('side', 'wrist', 'right', 'x');

    const pelvisForwardTilt = muscleData.calculateRiskData(res.body.side, "hip", "shoulder", "right", 13);
    Object.assign(pelvisForwardTilt, {
      key: 'pelvisForwardTilt',
      name: 'pelvisForwardTilt',
      position: 'pelvisForwardTilt',
      level: ''
    });

    const headForwardDistance = muscleData.riskObject(14);
    const depthEarShoulderDistance = getDepthPointDistance('side', 'Ear', 'Shoulder', 'right', 'x');
    const earShoulderXDistance = Math.abs(shoulderX - earX);
    const hipShoulderYDistance = Math.abs(hipY - shoulderY);
    const hasDepthEarShoulderDistance = depthEarShoulderDistance !== null;
    const headForwardRatio = hipShoulderYDistance > 0 ? (earShoulderXDistance / hipShoulderYDistance) * 100 : 0;
    Object.assign(headForwardDistance, {
      raw: hasDepthEarShoulderDistance ? depthEarShoulderDistance : headForwardRatio,
      unitType: hasDepthEarShoulderDistance ? 'mm' : 'percent',
      key: 'headForwardDistance',
      name: 'headForwardDistance',
      position: 'headForwardDistance'
    });

    const wristHipDistanceLeft = muscleData.riskObject(15);
    const depthWristHipDistanceLeft = getDepthPointDistance('front', 'Wrist', 'Hip', 'left', 'x');
    const wristHipDiffLeft = Math.abs(hipXLeft - wristXLeft);
    const wristHipRatioLeft = hipShoulderYDistance > 0 ? (wristHipDiffLeft / hipShoulderYDistance) * 100 : 0;
    const hasDepthWristHipDistanceLeft = depthWristHipDistanceLeft !== null;
    Object.assign(wristHipDistanceLeft, {
      raw: hasDepthWristHipDistanceLeft ? depthWristHipDistanceLeft : wristHipRatioLeft,
      unitType: hasDepthWristHipDistanceLeft ? 'mm' : 'percent',
      key: 'wristHipDistanceLeft',
      name: 'wristHipDistanceLeft',
      position: 'wristHipDistanceLeft'
    });

    const wristHipDistanceRight = muscleData.riskObject(16);
    const depthWristHipDistanceRight = getDepthPointDistance('front', 'Wrist', 'Hip', 'right', 'x');
    const wristHipDiffRight = Math.abs(hipX - wristXRight);
    const wristHipRatioRight = hipShoulderYDistance > 0 ? (wristHipDiffRight / hipShoulderYDistance) * 100 : 0;
    const hasDepthWristHipDistanceRight = depthWristHipDistanceRight !== null;
    Object.assign(wristHipDistanceRight, {
      raw: hasDepthWristHipDistanceRight ? depthWristHipDistanceRight : wristHipRatioRight,
      unitType: hasDepthWristHipDistanceRight ? 'mm' : 'percent',
      key: 'wristHipDistanceRight',
      name: 'wristHipDistanceRight',
      position: 'wristHipDistanceRight'
    });

    risks.push(pelvisForwardTilt, headForwardDistance, wristHipDistanceLeft, wristHipDistanceRight);
    return risks;
  };

  onDoctorMsg = (e) => {
    let msg = e.target.value;
    this.setState({
      doctorMsg: msg,
    });
  };
  onSetDiagnosisName = (e) => {
    let doctorName = e.target.value;
    this.setState({
      doctorName,
    });
  };
  printPDF = () => {
    window.print();
  };
  onRefresh = () =>{
    window.location.reload();
  };
  onSaveData = (tag: string) => {
    if (tag == "print") {
      const { user, reportPageData } = this.state;
      // let user = this.state.user;
      let obj =
        user.filter((s) => {
          return s.name == "姓名";
        })[0] || {};
      let time = reportPageData.examinationReportResult.creationTimestamp || 0;
      let timeStr = moment(+time).format("YYYYMMDDHHmmss") || "";
      document.title = "体态报告-" + user[0].value + "-" + timeStr;
      this.printPDF();
      setTimeout(() => {
        document.title = "体态报告";
      }, 1000);
    } else {
      let data: any = {
        examinerResult: {
          ...this.state.examinerItem,
          name: this.state.doctorName,
        },
        doctorAdvice: this.state.doctorMsg,
      };
      this.props.saveExaminerResultAndUpdateExamination(data);
    }
  };

  goToLog = () => {
    window.location.href = "/log/static-reports/" + this.props.match.params.uuid + "?language=" + this.state.language
  }

  onChangeCurrentMoireImage = (imageUrl: string) => {
    const currentCanvasId = "backContourMapMoireImage";
    this.setState(
      {
        currentCanvasId,
        show: true,
        isSave: false,
        showModel: false,
        scaleBig: 1,
        showToolbox: false,
      },
      () => {
        const img = new Image();
        img.src = imageUrl;
        img.onload = () => {
          const drawImage = (scale: number) => {
            const canvas = document.getElementById(currentCanvasId + "big") as HTMLCanvasElement;
            const ctx = canvas?.getContext("2d");
            if (!canvas || !ctx) return;

            ctx.clearRect(0, 0, canvas.width, canvas.height);
            const imageScale = Math.min(canvas.width / img.width, canvas.height / img.height) * scale;
            const width = img.width * imageScale;
            const height = img.height * imageScale;
            const x = (canvas.width - width) / 2;
            const y = (canvas.height - height) / 2;
            ctx.drawImage(img, x, y, width, height);
          };

          drawImage(1);
          this.currentPosture = { setScale: drawImage } as any;
        };
      }
    );
  };

  onChangeCurrentCanvasId = (currentCanvasId: CanvasEnum) => {
    let reportPageData = this.state.reportPageData || {};
    this.setState({ currentCanvasId });
    let data: DotData[] = formatData({ data: reportPageData.postureData, direction: currentCanvasId });
    let img = this.state.frontImg;
    if (currentCanvasId == "back") {
      img = this.state.backImg;
    }
    if (currentCanvasId == "front") {
      img = this.state.frontImg;
    }
    if (currentCanvasId == "otherSide") {
      img = this.state.otherSideImg;
    }
    if (currentCanvasId == "side") {
      img = this.state.sideImg;
    }
    let show = this.state.show;

    this.setState(
      {
        currentImg: img,
        show: !show,
        isSave: false,
        showModel: false,
        scaleBig: 1,
      },
      () => {
        let c: any = currentCanvasId + "big";
        this.currentPosture = new PostureData({
          canvasId: c,
          img: img,
          data: data,
          directon: currentCanvasId,
          risks: reportPageData.postureData.body,
          width: this.state.clientWidth,
          height: this.state.clientHeight,
        });
      }
    );
  };
  onClosePosture = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    let showModel = this.state.showModel;
    let isSave = this.state.isSave;
    let show = true;
    if (isSave) {
      show = false;
    }
    this.setState({
      show: show,
      showModel: !showModel,
    });
  };
  onUpdateSaveStatus = () => {
    let isSave = !this.state.isSave;
    this.setState({
      isSave: isSave,
    });
  };
  onSetRiskItem = (riskItem: RiskResult) => {
    let key = riskItem.key + riskItem.direction;
    let detaiKey = key + "detail";

    let reportPageData = this.state.reportPageData || {};
    this.setState(
      {
        riskItem,
      },
      () => {
        try {
          new RiskDetailCanvas(reportPageData.postureData, riskItem);
        } catch (error: any) {
          console.log(error);
        }
      }
    );
    this.onShowDetail();
  };
  onCancle = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    this.setState({
      isSave: false,
      showModel: false,
    });
  };
  onOk = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    this.setState({
      isSave: false,
      showModel: false,
      show: false,
    });
  };
  onUpdatePoint = () => {
    let orginPoints: any = this.state.posture;
    let currentPosture = this.currentPosture;
    let currentPoints = window["pointList"];
    let scaleX = this.currentPosture.scaleX;
    let scaleY = this.currentPosture.scaleY;

    orginPoints = _.cloneDeep(orginPoints);
    currentPoints = _.cloneDeep(currentPoints);

    currentPoints.forEach((point) => {
      let partDirection = point.partDirection;
      let position = point.position;
      position.x = position.x / scaleX;
      position.y = position.y / scaleY;
      let name = point.name;
      let direction: Direction = point.direction;
      if (orginPoints.body && orginPoints.body[direction] && orginPoints.body[direction].points) {
        if (partDirection && partDirection.length) {
          orginPoints.body[direction].points[name][partDirection] = position;
        } else {
          orginPoints.body[direction].points[name] = position;
        }
      }
    });
    // console.log({orginPoints})
    this.props.updatePosturePoints(orginPoints);
  };
  onExaminerItem = (examinerItem: ExaminerResult) => {
    this.setState({
      examinerItem: examinerItem,
      doctorName: (examinerItem.name as any) || "",
      slide: false,
    });
  };
  onSavaPostureData = () => {
    message.success({ content: "保存成功", duration: 3 });
    this.setState({
      isSave: true,
    });
  };
  onCancleUpdatePoint = () => {
    // 重置覆盖层内容并隐藏
    if (this.overlayManager) {
      this.overlayManager.resetOverlay();
      // 如果镜像是激活的，在关闭时也要处理
      if (this.overlayManager.isMirrorCurrentlyActive()) {
        // 保存当前镜像状态
        const mirrorAxis = this.overlayManager.getMirrorAxis();
        // 临时取消镜像以保存原始状态
        this.overlayManager.toggleMirror(mirrorAxis);
      }
      // 清除overlay管理器
      this.overlayManager = null;
    }
    this.setState({ show: false });
  };
  // 放大
  onZoomIn = () => {
    let scaleBig = this.state.scaleBig + 0.1;
    this.setState({
      scaleBig,
    });
    this.currentPosture.setScale(scaleBig, true);
    
    // 同步覆盖层canvas的缩放
    if (this.overlayManager && this.overlayManager['synchronizeScale']) {
      this.overlayManager['synchronizeScale'](scaleBig);
    }
  };
  // 缩小
  onZoomOut = () => {
    let scaleBig = this.state.scaleBig - 0.1;
    this.setState({
      scaleBig,
    });
    this.currentPosture.setScale(scaleBig, true);
    
    // 同步覆盖层canvas的缩放
    if (this.overlayManager && this.overlayManager['synchronizeScale']) {
      this.overlayManager['synchronizeScale'](scaleBig);
    }
  };

  // 工具箱功能
  onToolClick = (tool: string) => {
    const canvas = document.getElementById(this.state.currentCanvasId + "big") as HTMLCanvasElement;
    if (!canvas) return;
    
    // 如果还没有管理器，创建新的
    if (!this.overlayManager) {
      this.overlayManager = new OverlayCanvasManager(canvas);
    }
    
    if (tool === 'mirror') {
      // 镜像功能是切换模式，不是普通的工具激活
      // 调用toggleMirror方法切换镜像状态，并获取新的镜像状态
      const isMirrorActive = this.overlayManager.toggleMirror('horizontal');
      
      // 更新activeTool以反映镜像状态
      if (isMirrorActive) {
        this.setState({ activeTool: tool });
      } else {
        // 当镜像关闭时，如果当前activeTool是镜像，则清除
        if (this.state.activeTool === 'mirror') {
          this.setState({ activeTool: '' });
        }
      }
    } else {
      // 其他工具的正常处理
      this.setState({ activeTool: tool });
      
      // 切换到其他工具
      this.overlayManager.activate(tool);
    }
  };

  applyToolToCanvas = (tool: string) => {
    if (!this.currentPosture || !this.state.show) return;

    const canvas = document.getElementById(this.state.currentCanvasId + "big") as HTMLCanvasElement;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    switch (tool) {
      case "protractor":
        this.enableProtractorMode(ctx);
        break;
      case "ruler":
        this.enableRulerMode(ctx);
        break;
      case "drag":
        this.enableDragMode();
        break;
      case "mirror":
        this.enableMirrorMode(ctx);
        break;
      case "crop":
        this.enableCropMode(ctx);
        break;
      case "point":
        this.enablePointMode(ctx);
        break;
      case "vertical":
        this.enableVerticalLineMode(ctx);
        break;
      case "horizontal":
        this.enableHorizontalLineMode(ctx);
        break;
      case "verticalAngle":
        this.enableVerticalAngleMode(ctx);
        break;
      case "horizontalAngle":
        this.enableHorizontalAngleMode(ctx);
        break;
      default:
        this.disableAllTools();
    }
  };

  // 空的enableProtractorMode方法，因为我们现在使用OverlayCanvasManager
  enableProtractorMode = (ctx: CanvasRenderingContext2D) => {
    // 这个方法现在为空，因为工具激活逻辑已经在onToolClick中处理
  };

  enableRulerMode = (ctx: CanvasRenderingContext2D) => {
    // 实现直尺功能
    console.log("直尺模式已启用");
  };

  enableDragMode = () => {
    // 实现拖动模式
    console.log("拖动模式已启用");
  };

  enableMirrorMode = (ctx: CanvasRenderingContext2D) => {
    // 实现镜像功能
    console.log("镜像模式已启用");
  };

  enableCropMode = (ctx: CanvasRenderingContext2D) => {
    // 实现截取功能
    console.log("截取模式已启用");
  };

  enablePointMode = (ctx: CanvasRenderingContext2D) => {
    // 实现标点功能
    console.log("标点模式已启用");
  };

  enableVerticalLineMode = (ctx: CanvasRenderingContext2D) => {
    // 实现垂线功能
    console.log("垂线模式已启用");
  };

  enableHorizontalLineMode = (ctx: CanvasRenderingContext2D) => {
    // 实现水平线功能
    console.log("水平线模式已启用");
  };

  enableVerticalAngleMode = (ctx: CanvasRenderingContext2D) => {
    // 实现垂线夹角功能
    console.log("垂线夹角模式已启用");
  };

  enableHorizontalAngleMode = (ctx: CanvasRenderingContext2D) => {
    // 实现水平夹角功能
    console.log("水平夹角模式已启用");
  };

  disableAllTools = () => {
    this.setState({ activeTool: '' });
    console.log("所有工具已禁用");
  };

  toggleToolboxVisibility = () => {
    this.setState(prevState => ({
      showToolbox: !prevState.showToolbox
    }));
  };

  render() {
    let risksLabels = this.state.risksLabels.filter((s) => {
      return s && s.trim();
    });
    let risks = this.state.risks.filter((risk) => {return risk.key != ''}).map((item) => {
      if (item.level == "severe") {
        item.level = "high";
      }
      if (item.level == "mild") {
        item.level = "middle";
      }
      return item;
    });
    let scoliosis: any = risks
      .filter((item) => {
        return item.key == "scoliosis";
      })
      .pop() || { raw: 0, direction: "" };
    let lateralhead: any = risks
      .filter((item) => {
        return item.key == "lateralhead";
      })
      .pop() || { raw: 0, direction: "" };
    let unevenshoulder: any = risks
      .filter((item) => {
        return item.key == "unevenshoulder";
      })
      .pop() || { raw: 0, direction: "" };
    let unevenhip: any = risks
      .filter((item) => {
        return item.key == "unevenhip";
      })
      .pop() || { raw: 0, direction: "" };
    let forwardhead: any = risks
      .filter((item) => {
        return item.key == "forwardhead";
      })
      .pop() || { raw: 0, direction: "" };
    let roundedshoulder: any = risks
      .filter((item) => {
        return item.key == "roundedshoulder";
      })
      .pop() || { raw: 0, direction: "" };
    let kneehyperextension: any = risks
      .filter((item) => {
        return item.key == "kneehyperextension";
      })
      .pop() || { raw: 0, direction: "" };
    let trunkforwardtilt: any = risks
        .filter((item) => {
          return item.key == "trunkforwardtilt";
        })
        .pop() || { raw: 0, direction: "" };
    let trunklateraltilt: any = risks
        .filter((item) => {
          return item.key == "trunklateraltilt";
        })
        .pop() || { raw: 0, direction: "" };
    let ankleheelleft: any = risks
        .filter((item) => {
          return item.key == "ankleheelleft";
        })
        .pop() || { raw: 0, direction: "" };
    let ankleheelright: any = risks
        .filter((item) => {
          return item.key == "ankleheelright";
        })
        .pop() || { raw: 0, direction: "" };
    let headForwardDistance: any = risks
        .filter((item) => {
          return item.key == "headForwardDistance";
        })
        .pop() || { raw: 0, direction: "" };
    let pelvisForwardTilt: any = risks
        .filter((item) => {
          return item.key == "pelvisForwardTilt";
        })
        .pop() || { raw: 0, direction: "" };
    let wristHipDistanceLeft: any = risks
        .filter((item) => {
          return item.key == "wristHipDistanceLeft";
        })
        .pop() || { raw: 0, direction: "" };
    let wristHipDistanceRight: any = risks
        .filter((item) => {
          return item.key == "wristHipDistanceRight";
        })
        .pop() || { raw: 0, direction: "" };
    let olegleft: any = risks
      .filter((item) => {
        return ["oleg", "xoleg", "xleg"].includes(item.key) && item.direction == "left";
      })
      .pop() || { raw: 0, direction: "" };
    let olegright: any = risks
      .filter((item) => {
        return ["oleg", "xoleg", "xleg"].includes(item.key) && item.direction == "right";
      })
      .pop() || { raw: 0, direction: "" };
    let postureData: any = localStorage.getItem("angles") || {};

    try {
      postureData = JSON.parse(postureData);
    } catch (error: any) {}

    let directions = {
      front: <FormattedMessage id="front" />,
      side: <FormattedMessage id="side" />,
      back: <FormattedMessage id="back" />,
      otherSide: <FormattedMessage id="otherSide" />,
    };
    let posture = {
      front: [
        {
          name: <FormattedMessage id="lateralhead" />,
          id: "lateralhead",
          value: Math.abs(lateralhead.raw).toFixed(1),
          unit:
            lateralhead.direction == "right" ? (
              <FormattedMessage id="toTheRight" />
            ) : (
              <FormattedMessage id="toTheLeft" />
            ),
        },
        {
          name: <FormattedMessage id="unevenshoulder" />,
          id: "unevenshoulder",
          value: Math.abs(unevenshoulder.raw).toFixed(1),
          unit:
            unevenshoulder.direction == "right" ? (
              <FormattedMessage id="toTheRight" />
            ) : (
              <FormattedMessage id="toTheLeft" />
            ),
        },
        {
          name: <FormattedMessage id="scoliosis" />,
          id: "scoliosis",
          value: Math.abs(scoliosis.raw * 100).toFixed(1),
          unit: "",
        },
        {
          name: <FormattedMessage id="unevenhip" />,
          id: "unevenhip",
          value: Math.abs(unevenhip.raw).toFixed(1),
          unit:
            unevenhip.direction == "right" ? <FormattedMessage id="toTheRight" /> : <FormattedMessage id="toTheLeft" />,
        },
        {
          name: <FormattedMessage id="leg" />,
          id: "leg",
          value: Math.abs(olegleft.raw).toFixed(1),
          unit:
            olegleft.level == "normal" ? (
              <FormattedMessage id="bracketsNormal" />
            ) : (
              <FormattedMessage id="bracketsLeft" />
            ),
        },
        {
          name: <FormattedMessage id="leg" />,
          id: "leg",
          value: Math.abs(olegright.raw).toFixed(1),
          unit:
            olegright.level == "normal" ? (
              <FormattedMessage id="bracketsNormal" />
            ) : (
              <FormattedMessage id="bracketsRight" />
            ),
        },
      ],
      side: [
        {
          name: <FormattedMessage id="forwardhead" />,
          value: Math.abs(forwardhead.raw).toFixed(1),
          unit: "",
        },

        {
          name: <FormattedMessage id="roundedshoulder" />,
          value: Math.abs(roundedshoulder.raw).toFixed(1),
          unit: "",
        },
        {
          name: <FormattedMessage id="kneehyperextension" />,
          value: Math.abs(kneehyperextension.raw).toFixed(1),
          unit: "",
        },
        {
          name: <FormattedMessage id="trunkforwardtilt" />,
          value: Math.abs(trunkforwardtilt.raw).toFixed(1),
          unit: "",
        },
        {
          name: <FormattedMessage id="trunklateraltilt" />,
          value: Math.abs(trunklateraltilt.raw).toFixed(1),
          unit: "",
        },
        {
          name: <FormattedMessage id="ankleheelleft" />,
          value: ankleheelleft.raw.toFixed(1),
          unit: "",
        },
        {
          name: <FormattedMessage id="ankleheelright" />,
          value: ankleheelright.raw.toFixed(1),
          unit: "",
        },
        {
          id: "headForwardDistance",
          name: <FormattedMessage id="headForwardDistance" />,
          value: headForwardDistance.raw.toFixed(1),
          unit: "",
          valueUnit: headForwardDistance.unitType,
        },
        {
          id: "pelvisForwardTilt",
          name: <FormattedMessage id="pelvisForwardTilt" />,
          value: pelvisForwardTilt.raw.toFixed(1),
          unit: "",
        },
        {
          id: "wristHipDistanceLeft",
          name: <FormattedMessage id="wristHipDistanceLeft" />,
          value: wristHipDistanceLeft.raw.toFixed(1),
          unit: "",
          valueUnit: wristHipDistanceLeft.unitType,
        },
        {
          id: "wristHipDistanceRight",
          name: <FormattedMessage id="wristHipDistanceRight" />,
          value: wristHipDistanceRight.raw.toFixed(1),
          unit: "",
          valueUnit: wristHipDistanceRight.unitType,
        },
      ],
    };
    let historyList = [];
    try {
      let h = localStorage.getItem("historyList") || "[]";
      historyList = JSON.parse(h);
    } catch (error: any) {}
    let reportPageData = this.state.reportPageData;
    let riskItem = this.state.riskItem;
    let levles = {
      high: <FormattedMessage id="hAbnormalRisk" />,
      middle: <FormattedMessage id="mAbnormalRisk" />,
      normal: <FormattedMessage id="lAbnormalRisk" />,
    };
    let value = riskItem.value ? riskItem.value.toFixed(1) : 0;
    let doctorName = this.state.doctorName;
    let signature = this.state.signature;
    let directionName = {
      left: <FormattedMessage id="bracketsLeft" />,
      right: <FormattedMessage id="bracketsRight" />,
    };

    let clientHeight = this.state.clientHeight;
    let clientWidth = this.state.clientWidth;

    let mt = 0;

    let editable = UrlUtils.getQueryParameter("editable");
    if (editable == null) {
      editable = UrlUtils.getQueryParameter("isSave");
    }
    let isSave = editable == "true";
    let isAuth = this.state.isAuth;
    let orgName = this.state.orgName;
    let evaluateTime = this.state.evaluateTime;
    let doctorResume = this.state.doctorResume;
    let isDown = this.state.isDown;
    let directionList = this.state.directionList;
    const backContourMapMoireImageUrlValue = this.state.posture?.depthData?.find((item) => item.shootingAngle === "back")?.contourMapMoireImageUrl;
    const backContourMapMoireImageUrl = backContourMapMoireImageUrlValue ? String(backContourMapMoireImageUrlValue) : "";
    const postureDataCanvasCount = directionList.length + (backContourMapMoireImageUrl ? 1 : 0);
    return (
        <>
          {
            !isDown && (
                <div className="loading-style">
                  <img src={loading} width={200}/>
                  <div>
                    <FormattedMessage id="loading" />
                  </div>
                </div>
            )
          }
          {
            isDown &&
            (<div className="appReport appReportGait" id="appReport">
        <div className="print-firstPage">
          <div className={this.state.show ? "bigContext hideIn" : "bigContext hideOn"}>
            <div className="scaleText">
              <FormattedMessage id="movePosition" />
            </div>
            <div className="saveAndCancle">
              {isSave && (
                <div onClick={this.onUpdatePoint} className="savaData">
                  <FormattedMessage id="saveModify" />
                </div>
              )}
              <div onClick={this.onCancleUpdatePoint} className="canclesavaData">
                <FormattedMessage id="cancel" />
              </div>
              <div onClick={this.onZoomIn} className="canclesavaData">
                <FormattedMessage id="zoomIn" />
              </div>
              <div onClick={this.onZoomOut} className="canclesavaData">
                <FormattedMessage id="zoomOut" />
              </div>
              <div onClick={this.toggleToolboxVisibility} className="canclesavaData">
                <FormattedMessage id={this.state.showToolbox ? "hideToolbox" : "showToolbox"} />
              </div>
            </div>
            {this.state.showModel && (
              <div className="reportPagemodel">
                <div className="modelTitle">
                  <FormattedMessage id="confirmTheClose" />？
                </div>
                <div className="modelContent">
                  <FormattedMessage id="closeInfo" />
                </div>
                <div className="modelBtn">
                  <div onClick={this.onCancle} className="btnCancle">
                    <FormattedMessage id="cancel" />
                  </div>
                  <div onClick={this.onOk} className="btnOk">
                    <FormattedMessage id="Ok" />
                  </div>
                </div>
              </div>
            )}
            <canvas
              key={this.state.currentCanvasId}
              style={{ marginTop: mt }}
              width={clientWidth}
              height={clientHeight}
              id={this.state.currentCanvasId + "big"}
            ></canvas>
            
            {/* 工具箱 */}
            {this.state.show && this.state.showToolbox && (
              <Toolbox 
                onToolClick={this.onToolClick}
                activeTool={this.state.activeTool}
              />
            )}
          </div>
          {/* 标题和个人信息 */}
          <AppReportHead orgName={orgName} organizationLogo={logo} user={this.state.user} />
          {/*  体态数据++  */}
          <div className="appPostureData">
            <div className="appDataHead">
              <div className="appDataRect"></div>
              <div className="appDataText">
                <FormattedMessage id="postureData" />
              </div>
              <a onClick={this.goToLog.bind(this)} style={{position: 'absolute',right:'15px'}}>
                <FormattedMessage id="postureLogData" />
              </a>
            </div>
            {/* 体态数据canvas */}
            <div className={`appPostureDataCanvas ${postureDataCanvasCount >= 4 ? 'count-gte-4' : 'count-lt-4'}`}>
              {directionList.map((item) => {
                return (
                  <div className="canvasItem" key={item} onClick={this.onChangeCurrentCanvasId.bind(this, item)}>
                    <div className="direction">{directions[item]}</div>
                    <canvas className="postureCanvas" id={item}></canvas>
                  </div>
                );
              })}
              {backContourMapMoireImageUrl && (
                <div
                  className="canvasItem"
                  key="backContourMapMoireImage"
                  onClick={this.onChangeCurrentMoireImage.bind(this, backContourMapMoireImageUrl)}
                >
                  <div className="direction"><FormattedMessage id="moireImage" /></div>
                  <img className="postureCanvas" src={backContourMapMoireImageUrl} style={{ maxWidth: '100%', objectFit: 'contain' }} />
                </div>
              )}
            </div>
            {/* 体态数据正侧面详情 */}
            <div key="appPostureDataDetail" className="appPostureDataDetail">
              <div className="dataDetailItem">
                {["front", "side"].map((item) => {
                  return (
                    <>
                      {posture[item].map((riskItem, i) => {
                        let unit = <FormattedMessage id="degree" />;
                        if (riskItem.valueUnit == "mm") {
                          unit = <FormattedMessage id="mm" />;
                        } else if (riskItem.id == "scoliosis" || riskItem.id == "headForwardDistance" || riskItem.id == "wristHipDistanceLeft" || riskItem.id == "wristHipDistanceRight") {
                          unit = <FormattedMessage id="percent" />;
                        }
                        return (
                          <div key={`${item}_${i}`} className="riskItemDetail">
                            <div className="levelArc">
                              <span className="degreeText">{riskItem.value || ""}</span>
                              <span className="degree">{riskItem.value ? unit : ""}</span>
                            </div>
                            <div className="riskExplain">
                              {riskItem.name} {riskItem.unit}
                            </div>
                          </div>
                        );
                      })}
                    </>
                  );
                })}
              </div>
            </div>
          </div>
          {/* 肌肉状态 */}
          <MuscleCom />
        </div>
        <div className="splitLine">
          {/* 标题和个人信息 */}
          <AppReportHead orgName={orgName} organizationLogo={logo} user={this.state.user} />
        </div>
        {/* 风险评估 */}
        <div className="appReportRiskEvalute">
          <div className="appDataHead">
            <div className="appDataRect"></div>
            <div className="appDataText">
              <FormattedMessage id="riskAssessment" />
            </div>
          </div>
          <div className="riskLevelType">
            {["high", "middle", "normal"].map((item) => {
              let risk = risks.filter((ritem) => {
                return ritem.key != 'trunkforwardtilt' && ritem.key != 'trunklateraltilt' && ritem.key != 'ankleheelleft' && ritem.key != 'ankleheelright' && ritem.level == item;
              });
              let levles = {
                high: <FormattedMessage id="hAbnormalRisk" />,
                middle: <FormattedMessage id="mAbnormalRisk" />,
                normal: <FormattedMessage id="lAbnormalRisk" />,
              };
              let levleBgs = {
                high: highRiskBg,
                middle: middleRiskBg,
                normal: normalRiskBg,
              };
              return (
                <div key={item} className={"riskLevelTypeItem"}>
                  {risk.length > 0  && <Divider orientation="left" className={"print-none"}>
                    {risk.length}
                    <FormattedMessage id="item" />
                    {levles[item]}
                  </Divider>}
                  {risk.length > 0 && <div className={"riskList "}>
                    {risk.map((riskItem, index) => {
                      let direction = "";
                      riskItem.description = getRiskByMuscleKey(riskItem.key);
                      if (riskItem.key.indexOf("leg") >= 0) {
                        direction = riskItem.direction;
                      }
                      return (
                        <div
                          key={index}
                          className={"riskEvaluteItem riskEvalute" + item}
                        >
                          <div className={"riskEvaluteItemLevel bg" + item}>{levles[item]}</div>
                          <div className="riskEvaluteImgs">
                            <canvas id={riskItem.key + direction} className=" canvasImg riskNameCanvas"></canvas>
                            <img id="riskNameImg" src={riskItem["D"]} className=" canvasImg riskNameImg"></img>
                            <input id={riskItem.key + "input"} type="hidden" />
                            <div className="riskEvalutePercent">
                              <div className="nameAndDirection">
                                <div className="riskName">{riskItem.name}</div>
                                <div className="riskDirection">
                                  {riskItem.direction ? directionName[riskItem.direction] : ""}
                                </div>
                              </div>

                              <div className="riskEvaluteLevel">
                                <span className="riskEvLeText">
                                  <FormattedMessage id="lRisk" />
                                </span>
                                <span className="riskEvLeText">
                                  <FormattedMessage id="mRisk" />
                                </span>
                                <span className="riskEvLeText">
                                  <FormattedMessage id="hRisk" />
                                </span>
                              </div>
                              <div className="riskEvPercent">
                                <div className="riskEvCircle" style={{ left: riskItem.value.toFixed(0) + "%" }}></div>
                                <div className="riskEvLine"></div>
                              </div>
                              <div className="riskEvPercentText " style={{ left: riskItem.value.toFixed(0) + "%" }}>
                                {riskItem.value.toFixed(1)}
                              </div>
                            </div>
                          </div>
                          <div className="tagList"></div>
                        </div>
                      );
                    })}
                    {[0, 2].map((item) => {
                      return <div key={item} className={"riskEvaluteItem stepPos riskEvalute" + item}></div>;
                    })}
                  </div>}
                </div>
              );
            })}
          </div>
          <div className="doctorMessagePrint">
                  <div className="appDataHead">
                    <div className="appDataRect"></div>
                    <div className="appDataText">
                      <FormattedMessage id="conclusionRecommendation" />
                    </div>
                  </div>
                  <div className="messageD">
                      <p>{this.state.doctorMsg}</p>
                  </div>
                  </div>
        </div>
        {/* 医嘱 */}
        <div style={{ pageBreakBefore: "auto" }} className="doctorMessage">
          <div className="appDataHead">
            <div className="appDataRect"></div>
            <div className="appDataText">
              <FormattedMessage id="conclusionRecommendation" />
            </div>
          </div>

          <div className="messageD">
            {isSave ? (
              <div
                id="doctorMsg"
                suppressContentEditableWarning
                className="header-advice"
                onChange={this.onDoctorMsg}
                contentEditable={isSave}
              >
                {this.state.doctorMsg}
              </div>
            ) : (
              <p>{this.state.doctorMsg}</p>
            )}
          </div>
          <div className="saveAndPrint">
            {isSave && (
              <div onClick={this.onSaveData.bind(this, "save")} className="saveReprotIcon">
                <FormattedMessage id="save" />
              </div>
            )}
            <div onClick={this.onSaveData.bind(this, "print")} className="printReprotIcon">
              <FormattedMessage id="print" />
            </div>
            {isSave && (
              <div className="printReprotIcon copy" data-clipboard-text={this.readonlyUrl()}>
                <FormattedMessage id="share" />
              </div>
            )}
            {isAuth && (
              <>
                <a
                  className="printReprotIcon"
                  href={
                    isSave
                      ? `https://solution.xingzheng.site/reports/customize-for/${
                          reportPageData.examinationReportResult &&
                          reportPageData.examinationReportResult.examineeReportDetailId
                        }?type=posture`
                      : `https://solution.xingzheng.site/reports/${
                          reportPageData.examinationReportResult &&
                          reportPageData.examinationReportResult.examineeReportDetailId
                        }?type=posture`
                  }
                >
                  <FormattedMessage id="solution" />
                </a>
              </>
            )}
          </div>
        </div>
        {/* 医师签名和基本信息 - 组件化 */}
        <DoctorSignatureSimple
            evaluator={signature}
            reportDate={evaluateTime}
            introduction={doctorResume}
        />
        {/* 风险详情 */}
        {this.state.isShowRiskDetail && (
          <div className="riskDetail">
            <div className="riskDetailBody">
              <div className="riskHead">
                <div className="riskdetailName">{riskItem.name}</div>
                <div className="backHistory" onClick={this.onShowDetail}>
                  <FormattedMessage id="return" />
                </div>
              </div>

              <div key={riskItem.key} className={"riskEvaluteItem riskEvaluteItemDetail riskEvalute" + riskItem.level}>
                <div className={"riskEvaluteItemLevel bg" + riskItem.level}>{levles[riskItem.level]}</div>
                <div className="riskEvaluteImgs">
                  <canvas id={riskItem.key + "detail"} className=" canvasImg riskNameCanvas"></canvas>
                  <img id="riskNameImg" src={riskItem["D"]} className=" canvasImg riskNameImg"></img>
                  <div className="riskEvalutePercent riskEvalutePercentDetail">
                    <div className="riskName">{riskItem.name}</div>
                    <div className="riskEvaluteLevel">
                      <span className="riskEvLeText">
                        <FormattedMessage id="lRisk" />
                      </span>
                      <span className="riskEvLeText">
                        <FormattedMessage id="mRisk" />
                      </span>
                      <span className="riskEvLeText">
                        <FormattedMessage id="hRisk" />
                      </span>
                    </div>
                    <div className="riskEvPercent">
                      <div className="riskEvCircle" style={{ left: value }}></div>
                      <div className="riskEvLine"></div>
                    </div>
                    <div className="riskEvPercentText " style={{ left: value }}>
                      {value}
                    </div>
                  </div>
                </div>
              </div>
              <div className="riskDetailContent">
                <div className="riskDetailRiskLevel riskdetailName">{levles[riskItem.level]}</div>
                <div className="riskDetailList">
                  <div className="riskDetailItem">
                    <div className="riskDetailItemContext">
                      <div className="riskDetailItemDot"></div>
                      <div className="riskDetailItemCont">{riskItem.description}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="closeRiskDetail" onClick={this.onShowDetail}></div>
            </div>
          </div>
        )}
        <p className="media-print text-foot">
          准确性声明: 本系统作为专业人士辅助评估工具，其评估结论不可直接作为诊断结论
        </p>

        <ToastContainer />
      </div>)
          }
        </>
    );
  }
}

function mapStateToProps(state: RootState): ReportProps {
  return {
    reportPageData: state.institution.reportPageData,
    examinerResult: state.institution.examinerResult,
    institution: state.institution.institution,
  };
}
function mapDispatchToProps(dispatch: ThunkDispatch<RootState, null, AnyAction>): ReportDispatchProps {
  return {
    updatePosturePoints(args) {
      dispatch(updatePosturePoints(args));
    },
    getReportPageDataByUuidAndExamineeId(args) {
      dispatch(getReportPageDataByUuidAndExamineeId(args));
    },
    saveExaminerResultAndUpdateExamination(args) {
      dispatch(saveExaminerResultAndUpdateExamination(args));
    },
    getExaminerResult() {
      dispatch(getExaminerResult());
    },
  };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Report) as any);
